import styled from '@emotion/styled'

type Props = {
  authUrl: string
  children?: React.ReactNode
}

/**
 * 외부 SSO 로그인 진입 링크(앵커) 버튼.
 * - `<a>` 태그를 사용해 외부 SSO 엔드포인트(혹은 내부 브릿지 경로)로 전체 페이지 이동.
 */
export const ExternalLoginButton = ({ authUrl, children }: Props) => {
  return (
    <StyledAnchor href={authUrl} target="_self">
      {children}
    </StyledAnchor>
  )
}

const StyledAnchor = styled.a`
  text-decoration: underline;
`
